export default "__VITE_ASSET__78296197__"